import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShebaGtmModule, provideGtmEvent } from 'app/core/services/google-tag-manager/gtm.directive';
import { useCurrentTemplate } from 'app/core/services/google-tag-manager/use-current-template';
import { SharedService } from 'app/core/services/shared.service';
import { ShebaAppLinksComponent } from '../../../shared/components/app-links/app-links.component';
import { ShebaBestHospitalComponent } from '../../../shared/components/best-hospital/best-hospital.component';
import { EmailSignupFormComponent } from '../../../shared/components/email-signup-form/email-signup-form.component';
import { ShebaSocialMediaLinksComponent } from '../../../shared/components/social-media-links/social-media-links.component';
import { RouterLinkDetectorDirective } from '../../directives/router-link-detector.directive';
import { Footer } from '../../models/footer.model';
import { CmsMediaPrefixPipe } from '../../pipes/cms-media-prefix.pipe';
import { ShebaFooterLinksComponent } from '../footer-links/footer-links.component';
import { NavigationComponent } from '../navigation/navigation.component';
import { ShebaLogoLinkComponent } from './logo-link.component';
import { useCookieConsentDialog } from 'app/shared/components/cookie-consent-dialog/use-cookie-consent-dialog';

@Component({
  selector: 'sheba-footer',
  standalone: true,
  host: {
    class: 'flex flex-col gap-5 bg-white py-14 dark:bg-[#012C31] dark:text-white'
  },
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EmailSignupFormComponent,
    NavigationComponent,
    ShebaSocialMediaLinksComponent,
    ShebaAppLinksComponent,
    ShebaBestHospitalComponent,
    ShebaFooterLinksComponent,
    MatRippleModule,
    CmsMediaPrefixPipe,
    TranslateModule,
    RouterLinkDetectorDirective,
    ShebaLogoLinkComponent,
    NgOptimizedImage,
    ShebaGtmModule
  ],
  providers: [provideGtmEvent({ event: 'footer', eventInfo: { template: useCurrentTemplate() } })]
})
export class ShebaFooterComponent {
  footerData = input<Footer>({} as Footer);
  lightMode = inject(SharedService).lightMode;
  cookieDialog = useCookieConsentDialog();

  ngOnInit(): void {
    this.cookieDialog.open();
  }
}
